import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";
import { WaiversPoliciesApi } from "@/openapi/generated";

const POLICIES_BY_USER_STALE_TIME_MS = 5 * 60 * 1000;

export async function prefetchWaivers(
  userId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching waivers");
  }

  if (!userId) {
    throw new Error("User ID is required for prefetching waivers");
  }

  // Prefetch all policies for the user by their user ID
  // This returns a paginated list with acceptance timestamps
  const authenticatedService = createAuthenticatedApi(
    WaiversPoliciesApi,
    accessToken,
  );

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Waivers, "byUserId", userId, 1, 1000, undefined],
    queryFn: () =>
      authenticatedService.apiPoliciesUserIdGet({
        id: userId,
        page: 1,
        pageSize: 1000,
        xTenantID: resolveEffectiveTenantNumber(),
      }),
    staleTime: POLICIES_BY_USER_STALE_TIME_MS,
  });

  return queryClient;
}
